module.exports = __webpack_public_path__ + "img/footerlogo.0d1668fa.png";